export const regexXMLurl =
  /^(https?|ftp|file|feed|webcal|mailto|tel|urn|news|irc|telnet|ldap|rtsp|sip|sips|mms):\S+\.xml$/i;

export function validateXMLurl(url: string) {
  return regexXMLurl.test(url);
}
